import {
  OPEN_TEAMS_WIZZARD,
  CLOSE_TEAMS_WIZZARD,
  WIZZARD_ADD_TEAM_SET_TEAM_NAME,
  WIZZARD_ADD_TEAM_SET_TEAM_CHAMPION,
  WIZZARD_ADD_TEAM_SET_TEAM_MEMBERS,
  WIZZARD_ADD_TEAM_REMOVE_TEAM_MEMBER,
  WIZZARD_ADD_TEAM_UPDATE_TEAM_MEMBER,
  myTeamsList,
  newUsers,
  REQUEST_INVITE_COMPANY,
  REQUEST_ADD_TEAM,
  REQUEST_ADD_TEAM_SUCCESS,
  REQUEST_INVITE_MORE_MEMBERS,
} from './types';

export * from './moveTeamMembers/actions';

export function openTeamsWizzard(startPath = false, options) {
  return {
    type: OPEN_TEAMS_WIZZARD,
    startPath,
    options,
  };
}

export function closeTeamsWizzard() {
  return {
    type: CLOSE_TEAMS_WIZZARD,
  };
}

export function setWizzardTeamName(teamName) {
  return {
    type: WIZZARD_ADD_TEAM_SET_TEAM_NAME,
    teamName,
  };
}

export function setWizzardTeamChampion(email) {
  return {
    type: WIZZARD_ADD_TEAM_SET_TEAM_CHAMPION,
    email,
  };
}

export function setWizzardTeamMembers(members) {
  return {
    type: WIZZARD_ADD_TEAM_SET_TEAM_MEMBERS,
    members,
  };
}

export function removeWizzardTeamMember(email) {
  return {
    type: WIZZARD_ADD_TEAM_REMOVE_TEAM_MEMBER,
    email,
  };
}

export function updateWizzardTeamMember(email, role) {
  return {
    type: WIZZARD_ADD_TEAM_UPDATE_TEAM_MEMBER,
    email,
    role,
  };
}

export function requestMyTeamsList() {
  return {
    type: myTeamsList.request,
  };
}

export function requestMyTeamsListSuccess(response) {
  return {
    type: myTeamsList.success,
    response,
  };
}

export function requestMyTeamsListFailure(error) {
  return {
    type: myTeamsList.failure,
    error,
  };
}

export function requestInviteCompany(networkId, payload, promise) {
  return {
    type: REQUEST_INVITE_COMPANY,
    networkId,
    payload,
    promise,
  };
}

export function requestAddTeam(companyId, payload, promise) {
  return {
    type: REQUEST_ADD_TEAM,
    companyId,
    payload,
    promise,
  };
}

export function requestAddTeamSuccess(teamId) {
  return {
    type: REQUEST_ADD_TEAM_SUCCESS,
    teamId,
  };
}

export function requestInviteMoreMembers(payload, promise) {
  return {
    type: REQUEST_INVITE_MORE_MEMBERS,
    payload,
    promise,
  };
}

export function requestInviteMoreUsers(userEmails, promise) {
  return {
    type: newUsers.request,
    userEmails,
    promise,
  };
}

export function requestInviteMoreUsersSuccess(userEmails) {
  return {
    type: newUsers.success,
    userEmails,
  };
}

export function requestInviteMoreUsersFailure(error) {
  return {
    type: newUsers.failure,
    error,
  };
}
